import ym from "react-yandex-metrika";

export enum YandexGoal {
  PhoneEntranceBtn = "PhoneEntranceBtn",
  OtpEntranceBtn = "OtpEntranceBtn",
  RegisterBtn = "RegisterBtn",
  RequestSmsBtn = "RequestSmsBtn",
  EnterSmsBtn = "EnterSmsBtn",
  SignUpBtn = "SignUpBtn",
  CreateAdOrderBtn = "CreateAdOrderBtn",
  CreateCampaignOrderBtn = "CreateCampaignOrderBtn",
  SmsSent_success = "SmsSent_success",
  SmsOtp_success = "SmsOtp_success",
  Register_success = "Register_success",
  BaleSignUp_success = "BaleSignUp_success",
  BaleSignUp_error = "BaleSignUp_error",
  SmsRequest_error = "SmsRequest_error",
  DialogPayment_success = "DialogPayment_success",
  DialogPayment_error = "DialogPayment_error",
  OrderDialog_success = "OrderDialog_success",
  OrderDialog_error = "OrderDialog_error",
  OrderOnboarding_success = "OrderOnboarding_success",
  OrderOnboarding_error = "OrderOnboarding_error",
  OrderCampaign_success = "OrderCampaign_success",
  OrderCampaign_error = "OrderCampaign_error",
  OpenPackagesModal = "OpenPackagesModal",
}

export const sendYandexGoal = (goal: YandexGoal, revenue?: number) => {
  if (revenue) {
    ym("reachGoal", goal, {
      order_price: revenue,
      currency: "IRR",
    });
  } else {
    ym("reachGoal", goal);
  }
};
